/**
 * Created by Rodrigo Quesada on 16/01/17.
 */
import {Injectable} from '@angular/core';
import {Observable, ReplaySubject} from 'rxjs';
import {ActivatedRouteSnapshot} from '@angular/router';
import {DeaRegistrationScreensManager} from './dea-registration/dea-registration-screens-manager.service';
import {DeaRegistrationInformationService} from '../../../../domain/model/licenses-certifications/dea/info/dea-registration-information.service';
import {ScreensManager, ScreensManagerDeps} from '../../../../components/sections/service/screen-manager.class';
import {Step} from '../../../../components/sections/service/step.class';
import {Screen} from '../../../../components/sections/service/screen.class';

export enum DeaScreens {
    REGISTRATION = 1,
    INFO
}

@Injectable()
export class DeaScreensManager extends ScreensManager {

    private _currentScreen$ = new ReplaySubject<Screen>(1);
    screenChange$: Observable<boolean> = this._currentScreen$.map(() => true).publishReplay(1).refCount();

    private _deaRegistrationInfoExists: boolean;

    constructor(smgm: ScreensManagerDeps,
                private readonly _deaRegistrationInformationService: DeaRegistrationInformationService,
                private readonly _deaRegistrationScreensManager: DeaRegistrationScreensManager) {
        super(smgm);

        this._deaRegistrationInformationService.changes$.switchMap(() => this.refresh()).subscribe(() => {});

        this.refreshed$ = Observable.from([{refreshed$: this.refreshed$}, this._deaRegistrationScreensManager])
            .map(it => it.refreshed$).combineAll()
            .map(values => (values as Array<boolean>).every(it => it));
    }

    init(step: Step) {
        this._deaRegistrationScreensManager.init(step.idToScreenMap[DeaScreens.REGISTRATION]);
        super.init(step);
    }

    setCurrentScreen(screen: Screen, route: ActivatedRouteSnapshot) {
        super.setCurrentScreen(screen, route);
        let screenId = +screen.id;
        if (screenId === DeaScreens.REGISTRATION) this._deaRegistrationScreensManager.setCurrentScreen(screen, route.firstChild);
        this._currentScreen$.next(screen);
    }

    hasPreviousScreen(): boolean {
        let screenId = +this._currentScreen!.id;
        if (screenId === DeaScreens.REGISTRATION) return this._deaRegistrationScreensManager.hasPreviousScreen();
        else return !this._deaRegistrationInfoExists;
    }

    hasNextScreen(): boolean {
        let screenId = +this._currentScreen!.id;
        if (screenId === DeaScreens.REGISTRATION) return this._deaRegistrationScreensManager.totalItems > 0
            ? this._deaRegistrationScreensManager.hasNextScreen()
            : true;
        else return false;
    }

    navigateToPreviousScreen(): Observable<boolean> {
        let screenId = +this._currentScreen!.id;
        if (screenId === DeaScreens.REGISTRATION) return this._deaRegistrationScreensManager.navigateToPreviousScreen();
        else return this._deaRegistrationScreensManager.navigateToLastScreen();
    }

    nextScreenId(): string|number|undefined {
        let screenId = +this._currentScreen!.id;
        if (screenId === DeaScreens.REGISTRATION && this._deaRegistrationScreensManager.totalItems === 0) return DeaScreens.INFO;
    }

    navigateToNextScreen(): Observable<boolean> { return this._deaRegistrationScreensManager.navigateToNextScreen(); }

    firstScreenId(): string|number|undefined {
        if (this._deaRegistrationInfoExists) return DeaScreens.INFO;
    }

    navigateToFirstScreen(): Observable<boolean> { return this._deaRegistrationScreensManager.navigateToFirstScreen(); }

    lastScreenId(): string|number|undefined {
        if (this._deaRegistrationInfoExists) return DeaScreens.INFO;
    }

    navigateToLastScreen(): Observable<boolean> { return this._deaRegistrationScreensManager.navigateToLastScreen(); }

    protected _doRefresh(): Observable<any> {
        return this._deaRegistrationInformationService.doesCurrentUserModelExist().do(value => this._deaRegistrationInfoExists = value);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/licenses-certifications/steps/dea/dea-screens-manager.service.ts